textStrings.$inject = [];

/**
 * @ngdoc  service
 * @module csm.text
 * @name   csm.text.service:TextStrings
 *
 * @description
 * String manipulation tools.
 **/
/* @ngInject */ export function textStrings() {
  /**
   * @ngdoc       method
   * @name        toBoolean
   * @methodOf    csm.text.service:TextStrings
   * @param       {string}  input  Value to convert.
   * @param       {boolean} def    Default value if input is not valid.
   * @return      {boolean}        Boolean value.
   * @description
   * Converts `input` to boolean from case-insensitive "true" or "false".
   * Returns `def` if `input` is not valid. Throws exception if `def` is
   * not provided.
   */
  this.toBoolean = function (input, def) {
    switch ((input || '').toLowerCase()) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        if (!angular.isUndefined(def)) return def;
        throw "TextStrings.toBoolean: '" + input + "' is not a boolean value.";
    }
  };

  /**
   * @ngdoc       method
   * @name        toCamelCase
   * @methodOf    csm.text.service:TextStrings
   * @param       {string} name  kabob-case identifier.
   * @return      {string}       `name` in camelCase.
   * @description Converts kabob-case to camelCase.
   */
  this.toCamelCase = function (name) {
    return name
      ? name.replace(/-(\w)/g, function (m) {
          return m[1].toUpperCase();
        })
      : null;
  };

  /**
   * @ngdoc       method
   * @name        toKabobCase
   * @methodOf    csm.text.service:TextStrings
   * @param       {string} name  camelCase identifier.
   * @return      {string}       `name` in kabob-case.
   * @description Converts camelCase to kabob-case.
   */
  this.toKabobCase = function (name) {
    return name ? name.replace(/(?!^)([A-Z])/g, '-$1').toLowerCase() : null;
  };
}
